<template>
  <FileBaseMultiUploadRedesigned
    :modelValue="value"
    :label="label"
    :isOnce="isOnce"
    :readonly="readonly"
    :required="required"
    :accept="accept"
    :showEmpty="showEmpty"
    :description="description"
    :validExtensions="validExtensions"
    @addFile="fileChanged"
  >
    <template #preview>
      <div v-if="isOnce && value" class="inner-file">
        <template v-if="showPreview">
          <div class="file-preview">
            <a href="javascript:" @click.prevent="downloadFile(value)">
              <img :src="getFileUrl(value.id)" alt="" />
            </a>
          </div>
        </template>
        <p v-if="useCheckboxes">
          <input
            type="checkbox"
            v-model="value.checked"
            :disabled="readonly"
            class="mr-2"
            @click="itemChecked(value)"
          />
        </p>
        <p class="file-name fira-sans">{{ value.originalName }}</p>

        <div class="icons-container">
          <IconComponent @click.prevent="downloadFile(value)" name="download_transparent" />

          <IconComponent
            v-if="!iconCloseBtn && !readonly"
            title="Удалить"
            @click="$emit('deleteFile', value)"
            name="closeCross"
          />
        </div>
      </div>

      <div v-else-if="!isOnce && value.length" class="file-name-container">
        <template v-for="el in value" :key="el.id">
          <div class="inner-file">
            <template v-if="showPreview">
              <div class="file-preview">
                <a href="javascript:" @click.prevent="downloadFile(el)">
                  <img :src="getFileUrl(el.id)" alt="" />
                </a>
              </div>
            </template>
            <p v-if="useCheckboxes">
              <input type="checkbox" v-model="el.checked" :disabled="readonly" class="mr-2" @click="itemChecked(el)" />
            </p>
            <p class="file-name fira-sans">{{ el.originalName }}</p>

            <div class="icons-container">
              <IconComponent @click.prevent="downloadFile(el)" name="download_transparent" />

              <IconComponent
                v-if="!iconCloseBtn && !readonly"
                title="Удалить"
                @click="$emit('deleteFile', el)"
                name="closeCross"
              />
            </div>
          </div>
        </template>
      </div>
    </template>
  </FileBaseMultiUploadRedesigned>
</template>

<script>
  import FileAPI from '@/common/api/file';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';

  import FileBaseMultiUploadRedesigned from './FileBaseMultiUploadRedesigned.vue';

  export default {
    components: { IconComponent, FileBaseMultiUploadRedesigned },
    name: 'FileMultiUploadRedesigned',
    props: {
      label: String,
      entity: Object,
      propName: String,
      readonly: Boolean,
      required: {
        type: Boolean,
        default: false,
      },
      iconCloseBtn: {
        type: Boolean,
        default: false,
      },
      accept: String,
      userData: [Object, String, Number],
      showPreview: {
        type: Boolean,
        default: false,
      },
      useCheckboxes: {
        type: Boolean,
        default: false,
      },
      description: String,
      showEmpty: {
        type: Boolean,
        default: false,
      },
      isOnce: {
        type: Boolean,
        default: false,
      },
      validExtensions: {
        type: Array,
        default: () => [],
      },
    },
    emits: ['uploaded', 'deleteFile', 'checked'],
    data() {
      return {
        value: [],
      };
    },
    watch: {
      entity: {
        handler(newValue) {
          if (this.isOnce) {
            this.value = newValue;
          } else {
            this.value = newValue ? newValue[this.propName] : [];
          }
        },
        immediate: true,
      },
    },
    methods: {
      downloadFile(file) {
        FileAPI.download(file.id).then((response) => {
          const blob = new Blob([response.data], { type: file.contentType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = file.originalName;
          link.click();
          URL.revokeObjectURL(link.href);
        });
      },
      fileChanged(file) {
        FileAPI.upload(file)
          .then((response) => {
            this.$emit('uploaded', {
              propName: this.propName,
              data: response.data,
              userData: this.userData,
            });
          })
          .catch((e) => {
            console.log(e);
            Constants.alert.fire('Ошибка', 'Не удалось загрузить файл.', 'error');
          });
      },
      itemChecked(item) {
        this.$emit('checked', item);
      },
      getFileUrl(id) {
        return Utils.getFileUrl(id);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../../../assets/theme/default/colors';

  a:focus {
    box-shadow: none !important;
    outline: none !important;
  }

  .file-name-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .inner-file {
    display: flex;
    align-items: center;
    gap: 24px;

    @media (max-width: $laptop-2) {
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }

    :deep(.icon) {
      opacity: 0.7;
      color: #787f8f;
      margin-left: 14px;
    }
    .file-name {
      word-break: break-all;
    }
  }
  .icons-container {
    display: flex;
    margin-left: auto;
  }
  .file-preview {
    margin-right: 16px;
    img {
      width: 120px;
      height: auto;
    }
  }
</style>
